import { Flex } from 'components';
import styled from 'styled-components';

export const ProgramWrapper = styled(Flex)(({ theme }) => {
  return `
    background-size: 100%;
    background-position: top center;
    background-repeat: no-repeat;
    background-color: ${theme.colors.dark_350};
    align-items: flex-start;
  `;
});

export const LogoXP = styled.img`
  ${({ theme: { mediaQueries } }) => {
    return `
    max-width: 55px;

      ${mediaQueries.desktop} {
        max-width: 100px;
      }
    `;
  }}
`;

export const LogoInvestSmart = styled.img`
  ${({ theme: { mediaQueries } }) => {
    return `
    max-width: 200px;

      ${mediaQueries.desktop} {
        max-width: 300px;
      }
    `;
  }}
`;

export const LogoMelver = styled.img`
  ${({ theme: { mediaQueries } }) => {
    return `
    max-width: 150px;

      ${mediaQueries.desktop} {
        max-width: 220px;
      }
    `;
  }}
`;

export const LogoSafra = styled.img`
  ${({ theme: { mediaQueries } }) => {
    return `
    max-width: 120px;

      ${mediaQueries.desktop} {
        max-width: 200px;
      }
    `;
  }}
`;

export const LogoLiberta = styled.img`
  ${({ theme: { mediaQueries } }) => {
    return `
    max-width: 120px;

      ${mediaQueries.desktop} {
        max-width: 200px;
      }
    `;
  }}
`;
